export default defineNuxtPlugin(() => {
  const route = useRoute()
  const { enabled } = usePreviewMode({
    shouldEnable: () => !import.meta.dev && !!(route.query._storyblok && route.query._storyblok !== ''),
  })

  const version: 'draft' | 'published' = enabled?.value || import.meta.dev ? 'draft' : 'published'

  return {
    provide: {
      preview: enabled?.value,
      version,
    },
  }
})
